import {
  SendcloudContractStatus,
  SendcloudRegion,
} from "@redotech/redo-fulfillment-rate-common/carrier-account";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

const SendcloudContractClaimSchema_ = z.object({
  teamId: z.string(),
  teamName: z.string().nullable(),
  redoCarrierAccountId: z.string(),
  displayName: z.string(),
  enabled: z.boolean(),
});

const SendcloudPlatformContractSchema_ = z.object({
  sendcloudContractId: z.number(),
  region: createEnum(SendcloudRegion),
  carrierCode: z.string(),
  carrierName: z.string(),
  status: createEnum(SendcloudContractStatus),
  isDefaultPerCarrier: z.boolean(),
  country: z.string().nullable(),
  claim: SendcloudContractClaimSchema_.nullable(),
  missingOnSendcloud: z.boolean(),
});

export type SendcloudPlatformContract = z.infer<
  typeof SendcloudPlatformContractSchema_
>;
export const SendcloudPlatformContractSchema: z.ZodType<SendcloudPlatformContract> =
  SendcloudPlatformContractSchema_;

export const listSendcloudPlatformContracts = {
  name: "listSendcloudPlatformContracts" as const,
  input: z.object({ region: createEnum(SendcloudRegion) }),
  output: z.object({ contracts: z.array(SendcloudPlatformContractSchema) }),
};
